// extracted by mini-css-extract-plugin
export default {"container":"counter_container__LcQFP","round":"counter_round__hKmZc","count-label":"counter_count-label__1JB7O","square":"counter_square__AIwgS"};